import { render, staticRenderFns } from "./Dentista.vue?vue&type=template&id=69aed0ed&"
import script from "./Dentista.vue?vue&type=script&lang=js&"
export * from "./Dentista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports